import { Redirect } from 'expo-router';

/**
 * Legacy onboarding step. Forced onboarding was retired; role selection now
 * lives in the in-app `RoleSelectionSheet` (opened from /profile and the
 * Tour REDI sheet). Bounce any inbound traffic to the map so deep links
 * don't 404 — the file can be deleted once telemetry shows zero hits.
 */
export default function StakeholderTypeRedirect() {
  return <Redirect href="/(tabs)" />;
}
